import React, { useState, useEffect } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import style from "./styles.module.scss";
import LaddaButton, { SLIDE_LEFT } from "react-ladda";
import { LoadingField, FormSelect } from "../Controls";

const initialFields = {};

const ModalGroup = ({ open, toggle, services, group, onConfirm }) => {
  const [groups, setGroups] = useState(false);
  const [values, setValues] = useState([]);

  const [fields, setFields] = useState(initialFields);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (group) {
      setFields(group);
    } else {
      setFields(initialFields);
    }
  }, [group]);

  useEffect(() => {
    if (open) {
      services
        .assetGroups({})
        .then((res) => res.items)
        .then((items) => {
          setGroups(items);

          if (!group) {
            if (items.length > 0) {
              setFields({ ...fields, AssetGroupId: items[0].AssetGroupId });
            }
          }
        });
    }
  }, [open]);

  useEffect(() => {
    if (fields.AssetGroupId) {
      services
        .assetGroupValues({ groupId: fields.AssetGroupId })
        .then((res) => res.items)
        .then((items) => setValues(items));
    }
  }, [fields.AssetGroupId]);

  const onChange = (name, value) => {
    setFields({ ...fields, [name]: value });
    setErrors({ ...errors, [name]: undefined });
  };

  const handleSave = async () => {
    const errors = validate(fields);

    if (Object.keys(errors).length == 0) {
      setLoading(true);
      const { AssetGroupName } = groups.find((e) => e.AssetGroupId == fields.AssetGroupId);
      let result = await onConfirm({
        ...fields,
        AssetGroupName,
      });
      setLoading(false);

      if (result == 200) {
        toggle();
      }
    }
  };

  return (
    <Modal isOpen={open} toggle={toggle} className={style.modal}>
      <ModalHeader toggle={toggle}>Add asset group</ModalHeader>
      <ModalBody>
        {groups ? (
          <FormSelect
            name="AssetGroupId"
            label="Asset group"
            selectItems={groups}
            getSelectItemId={(i) => i.AssetGroupId}
            getSelectItemName={(i) => i.AssetGroupName}
            value={fields.AssetGroupId}
            onChange={onChange}
          />
        ) : (
          <LoadingField label="Asset group" />
        )}
        {values ? (
          <FormSelect
            name="AssetGroupValue"
            label="Asset group value"
            selectItems={values}
            getSelectItemId={(i) => i.Value}
            getSelectItemName={(i) => i.Value}
            value={fields.AssetGroupValue}
            onChange={onChange}
          />
        ) : (
          <LoadingField label="Asset group value" />
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="light" onClick={toggle}>
          Cancel
        </Button>
        <LaddaButton
          className="btn btn-ladda btn-primary pl-3 pr-3"
          loading={loading}
          disabled={false}
          onClick={() => handleSave()}
          data-style={SLIDE_LEFT}
        >
          <i className="fa fa-floppy-o mr-1" aria-hidden="true"></i>
          Save
        </LaddaButton>
      </ModalFooter>
    </Modal>
  );
};

function validate(fields) {
  Object.entries(fields).forEach(([name, value]) => {});

  return {};
}

export default ModalGroup;
